import { render, staticRenderFns } from "./CellList.vue?vue&type=template&id=38d5e878&scoped=true"
import script from "./CellList.vue?vue&type=script&lang=js"
export * from "./CellList.vue?vue&type=script&lang=js"
import style0 from "./CellList.vue?vue&type=style&index=0&id=38d5e878&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d5e878",
  null
  
)

export default component.exports